import React, { PureComponent } from 'react';
import PropTypes from "prop-types";

import * as styles from './style.css';
import { createClassNames, getMobileOperatingSystem } from "../../../../infrastructure/helpers";

const OS = getMobileOperatingSystem();

const DownloadAndroid = require('./img/android.png');
const DownloadAndroid2x = require('./img/android@2x.png');
const DownloadIOS = require('./img/ios.png');
const DownloadIOS2x = require('./img/ios@2x.png');

const DownloadAndroidBlack = require('./img/android-black.png');
const DownloadAndroidBlack2x = require('./img/android-black@2x.png');
const DownloadIOSBlack = require('./img/ios-black.png');
const DownloadIOSBlack2x = require('./img/ios-black@2x.png');

class StoreButton extends PureComponent {

  static defaultProps = {
    theme: 'white',
    appStore: 'https://apps.apple.com/ru/app/llama-moments/id1463320726',
    playMarket: 'https://play.google.com/store/apps/details?id=com.llama.client'
  };

  static propTypes = {
    playMarket: PropTypes.string,
    appStore: PropTypes.string,
    theme: PropTypes.string,
    containerClass: PropTypes.string
  };

  render() {
    const classNames = createClassNames([styles.controls, this.props.containerClass]);
    const iosHrefStyles = [styles.linkIOS];
    const androidHrefStyles = [styles.linkAndroid];
    if (this.props.theme === 'white') {
      iosHrefStyles.push(styles.shadow);
      androidHrefStyles.push(styles.shadow);
    }

    const iosHrefClassNames = createClassNames(iosHrefStyles);
    const androidHrefClassNames = createClassNames(androidHrefStyles);

    return (
      <div className={classNames}>
        {(OS === 'ios' || OS === null) && (
          <a href={this.props.appStore} target="_blank" className={iosHrefClassNames}>
            {this.props.theme === 'white' && (<img src={DownloadIOS} srcSet={DownloadIOS2x} className={styles.downloadIcon} />) }
            {this.props.theme === 'black' && (<img src={DownloadIOSBlack} srcSet={DownloadIOSBlack2x} className={styles.downloadIcon} />) }
          </a>
        )}
        {(OS === 'android' || OS === null) && (
          <a href={this.props.playMarket} target="_blank" className={androidHrefClassNames}>
            {this.props.theme === 'white' && (<img src={DownloadAndroid} srcSet={DownloadAndroid2x} className={styles.downloadIcon} />)}
            {this.props.theme === 'black' && (<img src={DownloadAndroidBlack} srcSet={DownloadAndroidBlack2x} className={styles.downloadIcon} />)}
          </a>
        )}
      </div>
    );
  }
}

export default StoreButton;


// WEBPACK FOOTER //
// ./src/app/modules/uq-ui/components/store-button/index.jsx